import { defaultCompare } from "./default-compare";

export const sortByField =
	<T, TKey extends keyof T>(sortKey: TKey, comparer: (a: T[TKey], b: T[TKey]) => number = defaultCompare) =>
	(a: T, b: T) =>
		comparer(a[sortKey], b[sortKey]);

const reduceComparisons = <T>(a: T, b: T, projections: Array<(x: T) => any>): number => {
	for (const projection of projections) {
		const result = defaultCompare(projection(a), projection(b));
		if (result) {
			return result;
		}
	}

	return 0;
};

export const sortBySelectors =
	<T>(...projections: Array<(x: T) => any>) =>
	(a: T, b: T) =>
		reduceComparisons(a, b, projections);

type Comparison<T> = { projection: (x: T) => any; order: number };

export const byAsc = <T>(projection: (x: T) => any) => ({ projection, order: 1 });
export const byDesc = <T>(projection: (x: T) => any) => ({ projection, order: -1 });

export const sortByComparisons =
	<T>(...comparisons: Array<Comparison<T>>) =>
	(a: T, b: T) => {
		for (const comparison of comparisons) {
			const { projection, order } = comparison;

			const result = defaultCompare(projection(a), projection(b));
			if (result === 0) continue;
			return result * order;
		}

		return 0;
	};

export const sortBy = <T>(array: Array<T>, ...comparisons: Array<Comparison<T>>): Array<T> => {
	const copy = array ? [...array] : [];
	copy.sort(sortByComparisons(...comparisons));
	return copy;
};
